import { HttpClient, HttpClientModule } from '@angular/common/http';
import {LOCALE_ID, NgModule} from '@angular/core';
import { SharedModule } from './modules/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { HoverPreloadModule } from 'ngx-hover-preload';
import { AppRoutingModule } from './app-routing.module';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
// import { FilterPacketsPipe } from './pipes/filter-packets.pipe';
// import * as NgHttpCachingModule from 'ng-http-caching';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HoverPreloadModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // NgHttpCachingModule,
    NgbModule,
  ],
  exports: [TranslateModule],
  providers: [TranslateService, {provide: LOCALE_ID, useValue: 'it-IT'}],
  bootstrap: [AppComponent],
})
export class AppModule {}
